//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    groupGetInfo,
    wxConfigAjax
} from '../../../../api';
import MHeader from '../../../Header/Header.vue';
export default {
    data() {
        return {
            data: null,
            pathName:""
        }
    },
    components: {
        MHeader
    },
    created() {
        this.$store.commit('showIsLoading');
        /*
            判断是否从拼团列表 还是 支付成功页面进入
            如果是支付成功进入合格页面 则参数传第二个
        */
        let test = this.pathName=='spellGroup'?
        `group_id=${this.$route.params.group_id}&groupbuy_id=${this.$route.params.groupbuy_id}`:
        `shop_id=${this.$route.params.group_id}&groupbuy_id=${this.$route.params.groupbuy_id}&tid=paysuccess`;

        groupGetInfo(test).then(res => {
            if (res.data.error_code) {
                this.$router.go(-1);
                console.error(res);
                return;
            };
            this.data = res.data.data;
            // 如果是待成团 就分享好友一起拼团 否则就分享商品
            if(this.data.groupbuyInfo.groupbuyEx==0 && this.data.groupbuyInfo.isFullGroup==0){
                wxConfigAjax({
                    title: `【拼团活动】` + this.data.groupbuyInfo.groupbuy_title,
                    desc: '【拼团活动】' + this.data.groupbuyInfo.groupbuy_title,
                    url: ``,
                    imgUrl: this.data.groupbuyInfo.groupbuy_image
                })
            }else{
                wxConfigAjax({
                    title: `【快买酒】` + this.data.groupbuyInfo.groupbuy_title,
                    desc: '【快买酒】' + this.data.groupbuyInfo.groupbuy_title,
                    url: `Detail/${this.data.groupbuyInfo.item_info.item_id}`,
                    imgUrl: this.data.groupbuyInfo.groupbuy_image
                })
            }
            console.log(this.data);
        });


    },
    methods:{
        back (){
            if(this.pathName=='spellGroup'){
                this.$router.go(-1)
            }else if (this.pathName == 'createOrder'){
                this.$router.go(-2);
            }else{
                this.$router.push({
                    name:'home'
                });
            };
        }
    },
    computed: {},
    filters: {
        status(val) {
            // 状态'expire'过期'agree'正常
            if (val == 'expire') {
                return
            }
        }
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm=>vm.pathName = from.name)
    }
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/spellGroup/Detail/Detail.vue